import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Logo } from '@/components/brand/logo';
import { dirOf } from '@/lib/i18n';

/**
 * המעטפת של כל דף שהלקוח של העסק פותח מקישור. בכותרת — העסק (זה הדף שלו מול
 * הלקוח שלו); הלוגו של המערכת רק קטן בתחתית, כחתימה.
 */
export function PublicShell({ business, children }: { business?: string; children: ReactNode }) {
  // useTranslation — כדי שהכיוון יתעדכן כשהשפה מוחלפת במקום (setLocale בלי reload).
  const { t } = useTranslation('public');
  return (
    <div dir={dirOf()} className="min-h-dvh bg-canvas">
      <header className="border-b border-border bg-surface">
        <div className="mx-auto max-w-md px-5 py-4">
          <p className="text-base font-semibold text-fg">{business ?? ' '}</p>
        </div>
      </header>
      <main className="mx-auto max-w-md px-5 py-6">{children}</main>
      <footer className="mx-auto flex max-w-md items-center justify-center gap-2 px-5 pb-8 text-2xs text-fg-subtle">
        {t('shell.poweredBy')}
        <Logo size="sm" />
      </footer>
    </div>
  );
}
